/*  */

var vettoreDefinitivo = [
  {
    voceTesta: "Chi Siamo",
    tipoVoce: "MenuVoceTitoloDropdown",
    tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
    pathGenerico: "/pages/chi-siamo-medicaltech",
    elementi: [
      {
        nome: "Mission",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Storia",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Dove Siamo",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Struttura Organizzativa",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Autorizzazione",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Certificazioni",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Brevetti",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Partner",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
    ],
  },
  {
    voceTesta: "Teleservizi",
    tipoVoce: "MenuVoceTitoloDropdown",
    tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
    pathGenerico: "/pages/teleservizi",
    elementi: [
      {
        nome: "Ambulatorio Digitale",
        tipoVoce: "MenuVoceTitoloDropdown",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Telerefertazione",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Telecooperazione",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Teleconsulto",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Ambulatorio Virtuale",
        tipoVoce: "MenuVoceTitoloDropdown",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Teleriabilitazione",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Telemonitoraggio",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Televisita",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Teleassistenza",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
    ],
  },
  {
    voceTesta: "Soluzioni",
    tipoVoce: "MenuVoceTitoloDropdown",
    tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
    pathGenerico: "/pages/soluzioni-medicaltech",
    elementi: [
      {
        nome: "CT64",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "SDIM",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "RI.CAR.DO.",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "ABPM",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "STAI SICURO",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "DIRAI*",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "TSM",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "SGC-FEA",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
    ],
  },
  {
    voceTesta: "Centro Servizi",
    tipoVoce: "MenuVoceTitoloDropdown",
    tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
    pathGenerico: "/pages/centro-servizi",
    elementi: [
      {
        nome: "Funzioni",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Garanzie",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
    ],
  },
  {
    voceTesta: "News",
    tipoVoce: "MenuVoceTitoloDropdown",
    tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
    pathGenerico: "/pages/news-medicaltech",
    elementi: [
      {
        nome: "Notizie",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
      {
        nome: "Eventi",
        tipoVoce: "MenuVoce",
        tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
      },
    ],
  },
  {
    voceTesta: "Contatti",
    tipoVoce: "MenuVoceTitoloDropdown",
    tipoVoceLaterale: "MenuVoceTitoloDropdownLaterale",
    pathGenerico: "/pages/contatto-aziendale-medicaltech",
    elementi: [],
  },
];
for (let index = 0; index < vettoreDefinitivo.length; index++) {
  try {
    const element = vettoreDefinitivo[index];
    SelezionaMostra(element.voceTesta, element.pathGenerico, element.tipoVoce);
    SelezionaMostra(
      element.voceTesta,
      element.pathGenerico,
      element.tipoVoceLaterale
    );
    for (let index2 = 0; index2 < element.elementi.length; index2++) {
      const element2 = element.elementi[index2];
      SelezionaMostra(element2.nome, element.pathGenerico, element2.tipoVoce);
      SelezionaMostra(
        element2.nome,
        element.pathGenerico,
        element2.tipoVoceLaterale
      );
    }
  } catch (e) {
    console.log(e);
  }
}
/*********************************************************************/
function SelezionaMostra(element, pathDesiderato, vocePrima, voceSeconda) {
  try {
    const tmp = document.getElementById(element + vocePrima);
    if (tmp && "addEventListener" in tmp) {
      tmp.addEventListener("click", (e) => {
        try { 
          if (window.location.pathname != pathDesiderato) {
            window.location.hash = element;
            window.location.pathname = pathDesiderato;
          }
          window.location.hash = element;
          const tmp = document.getElementById(element + "Link");
          tmp.scrollIntoView({ block: "center" });
          /* const tmp1 = document.getElementsByTagName("sticky-header");
          tmp1[0].reveal(); */
        } catch (e) {
          console.log(e);
        }
      });
    }

    const tmp2 = document.getElementById(element + voceSeconda);
    if (tmp2 && "addEventListener" in tmp2) {
      tmp2.addEventListener("click", (e) => {
        try { 
          if (window.location.pathname != pathDesiderato) {
            window.location.hash = element;
            window.location.pathname = pathDesiderato;
          }
          window.location.hash = element;
          const tmp2 = document.getElementById(element + "Link");
          tmp2.scrollIntoView({ block: "center" });
          /* const tmp1 = document.getElementsByTagName("sticky-header");
          tmp1[0].reveal(); */
        } catch (e) {
          console.log(e);
        }
      });
    }
  } catch (e) {
    console.log(e);
  }
}

/*  */

const vettorePath = [
  "/pages/chi-siamo-medicaltech",
  "/pages/soluzioni-medicaltech",
  "/pages/centro-servizi",
  "/pages/teleservizi",
  "/pages/news-medicaltech",
];
const ttt = vettorePath.includes(window.location.pathname);

if (
  vettorePath.includes(window.location.pathname) == true &&
  window.location.hash != ""
) {
  try { 
    let url = "";
    if (window.location.hash.substring(0, 1) == "#") {
      url = window.location.hash.substring(1);
    } else {
      url = window.location.hash;
    }
    const ttt = decodeURI(url);
    const tmp = document.getElementById(ttt + "Link");
    if (tmp && "scrollIntoView" in tmp) {
      tmp.scrollIntoView({ block: "center" });
    }
  } catch (error) {
    console.log(error);
  }
}

window.addEventListener("hashchange", function (e) { 
  const element = decodeURI(window.location.hash.substring(1));
  const tmp = document.getElementById(element + "Link");
  if (tmp) {
    tmp.scrollIntoView({ block: "center" });
    /* const tmp1 = document.getElementsByTagName("sticky-header");
    tmp1[0].reveal(); */
  }
});

window.addEventListener("locationchange", function (e) {
  console.log(e);
});

window.addEventListener("onload", function (e) {
  console.log(e);
});

const tmp = document.getElementsByClassName(
  "header__menu-item link link--text list-menu__item focus-inset"
);
/* const tmp = document.getElementsByClassName(
  "header__menu-item link link--text list-menu__item focus-inset caption-large"
); */

const tt = [];
for (let index = 0; index < tmp.length; index++) {
  const element = tmp[index];
  if (element.localName == "summary") {
    const ttt = element.textContent.trim();
    if (
      ttt == "Prestazioni sanitarie" ||
      ttt == "Accessori e Consumabili" ||
      ttt == "Manutenzione e Formazione"
    ) { 
      tt.push(element);
    }
  }
}
if (tt.length > 0) {
  tt[0].addEventListener("click", function (e) {
    setTimeout(() => {
      const temp = document
        .getElementById("Details-HeaderSubMenu-2")
        .removeAttribute("open");
    }, 100);
  });
}
if (tt.length > 1) {
  tt[1].addEventListener("click", function (e) {
    setTimeout(() => {
      const t = document
        .getElementById("Details-HeaderSubMenu-1")
        .removeAttribute("open");
    }, 100);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Ottieni il path attuale dell'URL
  var currentPath = window.location.pathname;

  // Verifica se il path corrisponde a "/registered"
  if (currentPath === "/account/register") {
    // Reindirizza a una pagina specifica, ad esempio il login
    window.location.href = "/account/login";
  }
});
